import { InvoiceDto, InvoiceInfoDto, IPagedCollection, LeadDto, UpdateLeadPropsDto } from '@sr/dto';
import { leadBaseApi } from 'entities/lead/api';
import { LEAD_BASE_URL } from 'shared/api/api';
import { IRemoteCollection } from 'utils/remote-collection.hook';

const injectedApi = leadBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLead: builder.query<LeadDto, number>({
      query: (id: number) => {
        return {
          url: `${LEAD_BASE_URL}/${id}/info`,
          method: 'GET',
        };
      },
    }),
    updateLead: builder.mutation<LeadDto, UpdateLeadPropsDto>({
      query: (dto: UpdateLeadPropsDto) => ({
        url: `${LEAD_BASE_URL}/${dto.id}`,
        body: dto,
        method: 'PUT',
      }),
    }),
    getLeadInvoices: builder.query<IPagedCollection<InvoiceInfoDto>, number>({
      query: (id: number) => {
        return {
          url: `${LEAD_BASE_URL}/${id}/invoices`,
          method: 'GET',
        };
      },
    }),
    // deleteLead: builder.mutation<void, number>({
    //   query: (id: number) => ({
    //     url: `${LEAD_BASE_URL}/${id}`,
    //     method: 'DELETE',
    //   }),
    // }),
  }),
  overrideExisting: true,
});

export const leadApi = injectedApi.enhanceEndpoints({
  addTagTypes: ['lead', 'leadInvoices'],
  endpoints: {
    getLead: {
      providesTags: (result, error, id) => [{ type: 'lead', id }],
    },
    getLeadInvoices: {
      providesTags: (result, error, id) => [{ type: 'leadInvoices', id }],
    },
    updateLead: {
      invalidatesTags: ['lead', 'lead-list'],
    },
  },
});

export const useLeadDetails = (id: number) => {
  const { data, isLoading, error } = leadApi.useGetLeadQuery(id, { refetchOnMountOrArgChange: true });
  return { data, isLoading, error };
};
